import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideServiceWorker } from '@angular/service-worker';
import {
	createInterceptorCondition,
	INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
	IncludeBearerTokenCondition,
	includeBearerTokenInterceptor,
	provideKeycloak,
} from 'keycloak-angular';
import { environment } from '../environments/environment';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
	urlPattern: new RegExp(/^(https?:\/\/)?(localhost|127\.0\.0\.1|0\.0\.0\.0|[a-zA-Z0-9-]+\.mottu\.(cloud|io)*)/i),
	bearerPrefix: 'Bearer',
});

export const appConfig: ApplicationConfig = {
	providers: [
		provideKeycloak({
			config: environment.keycloak,
			initOptions: {
				onLoad: 'login-required',
			},
		}),
		{
			provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
			useValue: [urlCondition],
		},
		provideRouter(routes),
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:5000',
		}),
		provideAnimations(),
		provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { appearance: 'outline' },
		},
	],
};
